<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@selection-change="handleSelectionChange" @current-change="handleCurrentChange" @search="handleSearch"
		@reset="resetQuery">
		<template slot="filters">
			<el-form-item label="电池" prop="word">
				<el-input v-model="query.word" placeholder="请输入电池名称/编号" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
			<el-form-item label="状态" prop="status">
				<el-select v-model="query.status" placeholder="请选择状态" clearable>
					<el-option label="在售" value="1"></el-option>
					<el-option label="停售" value="0"></el-option>
				</el-select>
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增电池
			</el-button>
			<el-button icon="el-icon-download" size="mini" type="primary" @click="handleExport">
				导出
			</el-button>
			<el-upload style="margin: 0 10px" action="" :show-file-list="false"
				:before-upload="handleImport">
				<el-button size="small" type="primary">批量导入</el-button>
			</el-upload>
			<el-button :disabled="ids.length == 0" size="mini" type="success" @click="handleBatchUpdate(1)">
				批量售卖
			</el-button>
			<el-button :disabled="ids.length == 0" size="mini" type="info" @click="handleBatchUpdate(0)">
				批量停售
			</el-button>
			<el-button icon="el-icon-download" size="mini" type="text" @click="handleDownload">
				下载模板
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column type="selection" width="50" align="center" />
			<el-table-column label="电池名称" align="center" prop="productName">
				<template slot-scope="{ row }">
					<el-row type="flex">
						<img style="max-height: 40px;max-width: 40px;margin-right: 10px" :src="row.coverImage" alt="">
						<div style="text-align: left;">
							<div>{{ row.name }}</div>
							<div style="color: #999; font-size: 12px">{{ row.sku }}</div>
						</div>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center" prop="status">
				<template slot-scope="{ row }">
					<el-tag :type="row.status == 1 ? 'success' : 'info'">
						{{ ['停售', '在售'][row.status] }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="{ row }">
					<el-link :underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link style="margin: 0 10px" :underline="false" :type="row.status == 1 ? 'info' : 'success'"
						@click="handleUpdate(row)">
						{{ row.status == 1 ? '停售' : '售卖' }}
					</el-link>
					<el-link :underline="false" type="danger" @click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, updateStatus, del, excelStencil, excel, importExcel } from "@/api/battery";
import listMixin from '@/mixins/list';
import utils from "@/jslibs/utils";

export default {
	data() {
		return {
			// 查询参数
			query: {
				word: "",
				status: undefined
			},
			ids: []
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/battery/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/battery/form", query: { id: row.id } });
		},
		handleSelectionChange(rows) {
			this.ids = rows.map(item => item.id);
		},
		handleUpdate(row) {
			updateStatus({ idList: [row.id], status: row.status == 1 ? 0 : 1 }).then(({ code, message }) => {
				if (code == 200) {
					this.$message.success("操作成功");
					this.search();
				} else {
					this.$message.error(message);
				}
			});
		},
		handleBatchUpdate(status) {
			updateStatus({ idList: this.ids, status }).then(({ code, message }) => {
				if (code == 200) {
					this.$message.success("批量操作成功");
					this.search();
				} else {
					this.$message.error(message);
				}
			});
		},
		handleDel(row) {
			this.$confirm("是否删除该电池?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
		handleExport() {
			excel(this.query).then(res => {
				const blob = new Blob([res]);
				const fileName = `电池列表.xls`;
				utils.downloadBlobFile(blob, fileName);
			});
		},
		handleDownload() {
			excelStencil().then(res => {
				const blob = new Blob([res]);
				const fileName = `电池模板.xls`;
				utils.downloadBlobFile(blob, fileName);
			})
		},
		handleImport(file) {
			importExcel({ file }).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success("导入成功");
                    this.handleSearch();
                } else {
                    this.$message.error(message);
                }
            });
            return false;
		}
	},
};
</script>